import { type InsightsClient } from 'instantsearch.js/es/types/insights';
import aa from 'search-insights';

import { API_KEY, APP_ID } from '../search-client';

aa('init', {
  appId: APP_ID,
  apiKey: API_KEY,
  useCookie: true,
});

const insightsConfig = {
  insightsClient: aa as InsightsClient,
};

export default insightsConfig;
